import(/* webpackChunkName: "semantic-theme" */"@semantic-theme").then(()=>{});
import React from 'react'
import { Icon, Sidebar, Button, Divider } from 'semantic-ui-react'
import styled from 'styled-components';
import { map } from 'lodash'

import { __ } from '~/i18n'
import {SegmentWithRef} from "~/components/semantic";
import { CartItem, CartTotal, CartHeader } from '~/components/cart'
import DiscountComponent from '~/scenes/discount'
import BlockingButton from '~/components/button'
import sizes from '~/components/sizes'

import logic from './logic'

import Empty from './empty'

const CloseContainer = styled.div`
  position: fixed;
  right: 475px;
  top: 20px;
  z-index: 100;
  
  .ui.button {
    margin: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    background: #FFF;
    box-shadow: 0 1px 3px 0 rgba(0,0,0,0.05), 0 16px 32px 0 rgba(0,0,0,0.10);
    border-color: #FFF;
  }
`;

const MobileCloseContainer = styled.div`
  position: absolute;
  left: 15px;
  top: 29px;
  z-index: 150;
`;

const Footer = styled.footer`
  flex-shrink: 0;
  padding-top: 30px !important;
  background: #FFF;
  padding-bottom: 0 !important;
`;

const Buttons = styled.div`
  .ui.button {
    margin-bottom: 8px;
  }
`;

const Contents = styled.div`
  overflow: auto;
  padding: 1rem;
  margin: -1rem;
  flex: 1;
`;
const CartContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - 65px);
  
  @media (max-width: 768px) {
    height: calc(100% - 55px);
  }
`;
const CartSegment = styled(SegmentWithRef)`
  &.ui.segment {
    padding: 40px;
    overflow: hidden !important;
  }
  
  &.ui.right.visible.sidebar {
    box-shadow: 0 0 32px 0 rgba(0,0,0,0.14);
    border-color: #FFF;
  }
  
  .ui.medium.header {
    margin-bottom: 24px;
  }
  
  @media (max-width: 768px) {
    &.ui[class*="very wide"].left.sidebar, &.ui[class*="very wide"].right.sidebar {
      width: 100%;
      padding: 16px;
    }
    
    .ui.medium.header {
      margin-bottom: 16px;
    }
  }
`;

const SidebarContainer = styled.div`
  position: relative;
  
  .left {
    float: none !important;
  }
`;

//TODO: review button icon/shadow
@sizes
@logic
export default class Cart extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      showCloseButton: false
    }
  }

  componentDidMount() {
    const { visible } = this.props;

    setTimeout(() => {
      this.setVisibility(visible);
    }, 0)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(prevProps.visible !== this.props.visible) {
      this.setVisibility(this.props.visible);
    }
  }

  setVisibility = (visibility) => {
    const { visible } = this.state;

    if(visibility !== visible) {
      this.setState({visible: visibility});
    }
  };

  handleClose = () => {
    const { closeCart } = this.props;
    this.setVisibility(false)
    this.setState({showCloseButton: false});
    closeCart();
  };

  handleQuantityChange = (item, quantity) => {
    const { changeQuantity } = this.props.actions;

    changeQuantity(item, quantity);
  };

  handleRemove = (item) => {
    const { removeItem } = this.props.actions;

    removeItem(item);
  };

  handleContinue = () => {
    const { next } = this.props;

    next()
  };

  render() {
    const { visible, showCloseButton } = this.state;
    const {
      count,
      activeCart,
      loading,
      hasContents,
      activeShop,
      isTiny
    } = this.props;
    let items, close;

    if(activeCart && activeCart.contents) {
      items = map(activeCart.contents, (cartItem) => {
        return (
          <CartItem key={cartItem.id} item={ cartItem } onQuantityChange={ this.handleQuantityChange } onRemove={ this.handleRemove } />
        )
      })
    }

    if(isTiny) {
      close = <MobileCloseContainer>
        <Icon name='close' onClick={ this.handleClose } link />
      </MobileCloseContainer>
    }else {
      close = <CloseContainer>
        <Button icon size='massive' onClick={ this.handleClose }>
          <Icon name='close' />
        </Button>
      </CloseContainer>
    }

    return (
      <SidebarContainer>
        { showCloseButton ? close : null }
        <Sidebar
          as={CartSegment}
          animation='overlay'
          icon='labeled'
          raised
          visible={ visible }
          direction='right'
          width='very wide'
          onHide={ () => { !visible && this.setState({showCloseButton: false}) }}
          onShow={() => { this.setState({showCloseButton: true}) }}
        >
          <CartHeader
            title={ __('Shopping Cart') }
            count={ count }
          />
          <Divider/>
          {hasContents ?
            <CartContainer>
              <Contents>
                {items}
              </Contents>
              <Footer>
                <DiscountComponent/>
                <Divider/>
                <CartTotal
                  cart={activeCart}
                  shop={activeShop}
                  loading={loading}
                />
                <Buttons>
                  <BlockingButton loading={loading} fluid positive onClick={this.handleContinue}>{__("Checkout")}</BlockingButton>
                  <BlockingButton basic loading={loading} fluid onClick={this.handleClose}>{__("Continue Shopping")}</BlockingButton>
                </Buttons>
              </Footer>
            </CartContainer>
            :
            <Empty onClose={ this.handleClose }/>
          }
        </Sidebar>
      </SidebarContainer>
    )
  }
}
